<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="headline lighten-2" primary-title>
          {{ headline }}
        </v-card-title>

        <v-card-text>
          <div class="editting-inputs" v-if="!commenting">
            <v-flex v-if="products.length == 1">
              <v-text-field
                v-model="editingProduct.barcode"
                :placeholder="placeholder.barcode"
                type="text"
                :label="$t('products_crud.barcode')"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="editingProduct.position"
                :placeholder="placeholder.position"
                type="text"
                :label="$t('products_crud.position')"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="editingProduct.type"
                :placeholder="placeholder.type"
                type="text"
                :label="$t('products_crud.type')"
              ></v-text-field>
            </v-flex>
            <div class="row">
              <div class="col">
                <v-text-field
                  v-model="editingProduct.width"
                  :placeholder="placeholder.width"
                  type="number"
                  :label="$t('products_crud.width')"
                ></v-text-field>
              </div>
              <div class="col">
                <v-text-field
                  v-model="editingProduct.height"
                  :placeholder="placeholder.height"
                  type="number"
                  :label="$t('products_crud.height')"
                ></v-text-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <v-text-field
                  v-model="editingProduct.depth"
                  :placeholder="placeholder.depth"
                  type="number"
                  :label="$t('products_crud.depth')"
                ></v-text-field>
              </div>
              <div class="col">
                <v-text-field
                  v-model="editingProduct.weight"
                  :placeholder="placeholder.weight"
                  type="number"
                  :label="$t('products_crud.weight')"
                ></v-text-field>
              </div>
            </div>
            <v-flex>
              <v-text-field
                v-model="editingProduct.area"
                :placeholder="placeholder.area"
                type="number"
                :label="$t('products_crud.area')"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="editingProduct.status"
                :placeholder="placeholder.status"
                type="number"
                :label="$t('products_crud.status')"
                v-if="!creating"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="editingProduct.category"
                :placeholder="placeholder.category"
                type="number"
                :label="$t('products_crud.category')"
              ></v-text-field>
            </v-flex>
            <v-flex v-if="products.length == 1">
              <v-text-field
                v-model="editingProduct.comment"
                type="text"
                :label="$t('products_crud.comment')"
              ></v-text-field>
            </v-flex>
          </div>
          <div v-else>
            <v-textarea
              name="input-7-1"
              :label="$t('products_crud.comment')"
              box
              height="70"
              v-model="comment"
            ></v-textarea>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="confirmChanges"
            v-if="!commenting"
          >
            {{ $t("product_edit.save") }}
          </v-btn>
          <v-btn color="primary" flat @click="saveComment" v-else>
            {{ $t("product_edit.save") }}
          </v-btn>
          <v-btn color="primary" flat @click="dialog = false">
            {{ $t("product_edit.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Helper from "@/models/Helper.js";
import Product from "@/models/Product.js";
export default {
  data() {
    return {
      dialog: false,
      editingProduct: {},
      placeholder: {},
      creating: false,
      commenting: false,
      headline: "",
      comment: "",
      products: [],
      onKeyUp: (e) => {
        if (e.key === "Escape") {
          this.dialog = false;
        }
        if (e.key === "Enter") {
          if (this.commenting) {
            this.saveComment();
          } else {
            this.confirmChanges();
          }
        }
      },
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        this.editingProduct = {};
        this.placeholder = {};
        this.creating = false;
        this.headline = "";
        this.products = [];
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    },
  },
  methods: {
    openComment(products) {
      this.creating = false;
      this.headline = this.$t("product_edit.write_comment");
      this.commenting = true;
      if (!Array.isArray(products)) {
        products = [products];
      }
      this.products = products;
      this.dialog = true;
    },
    openEdit(products) {
      this.creating = false;
      this.commenting = false;
      this.headline = this.$t("product_edit.edit_products");
      let placeholder = {
        barcode: "",
        position: "",
        type: "",
        width: "",
        height: "",
        depth: "",
        weight: "",
        area: "",
        status: "",
        category: "",
      };
      this.products = products;

      products.forEach((product) => {
        placeholder.barcode = Helper.getSettingPlaceholder(
          placeholder.barcode,
          product.barcode
        );
        placeholder.position = Helper.getSettingPlaceholder(
          placeholder.position,
          product.position
        );
        placeholder.type = Helper.getSettingPlaceholder(
          placeholder.type,
          product.type
        );
        placeholder.width = Helper.getSettingPlaceholder(
          placeholder.width,
          product.width
        );
        placeholder.height = Helper.getSettingPlaceholder(
          placeholder.height,
          product.height
        );
        placeholder.depth = Helper.getSettingPlaceholder(
          placeholder.depth,
          product.depth
        );
        placeholder.weight = Helper.getSettingPlaceholder(
          placeholder.weight,
          product.weight
        );
        placeholder.area = Helper.getSettingPlaceholder(
          placeholder.area,
          product.area
        );
        placeholder.status = Helper.getSettingPlaceholder(
          placeholder.status,
          product.status
        );
        placeholder.category = Helper.getSettingPlaceholder(
          placeholder.category,
          product.category
        );
      });
      this.placeholder = placeholder;
      this.dialog = true;
    },

    async confirmChanges() {
      await Product.recalculateProducts(this.products, this.editingProduct);
      this.dialog = false;
      this.$emit("updated");
    },

    async saveComment() {
      await Product.saveProductsComment(this.comment, this.products);
      this.comment = "";
      this.dialog = false;
      this.$emit("updated");
    },
  },
};
</script>
